import { render, staticRenderFns } from "./CargoBasic.vue?vue&type=template&id=3e19c0ea&scoped=true&"
import script from "./CargoBasic.vue?vue&type=script&lang=js&"
export * from "./CargoBasic.vue?vue&type=script&lang=js&"
import style0 from "./CargoBasic.vue?vue&type=style&index=0&id=3e19c0ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e19c0ea",
  null
  
)

export default component.exports